// localStorage-backed saved views for the admin overview dashboard.

export type SavedView = {
  id: string;
  name: string;
  range: { preset: string; from: string; to: string };
  scope: { orgId: string | null; deptId: string | null; assocId: string | null };
  activityMetric?: "recordings" | "audio_minutes";
};

const KEY = "admin.overview.savedViews";

export function loadSavedViews(): SavedView[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (v): v is SavedView =>
        typeof v === "object" &&
        v !== null &&
        typeof (v as SavedView).id === "string" &&
        typeof (v as SavedView).name === "string",
    );
  } catch {
    return [];
  }
}

export function saveSavedViews(views: SavedView[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(views));
  } catch {
    /* localStorage may be disabled */
  }
}

export function newViewId(): string {
  return `${Date.now()}-${Math.floor(Math.random() * 1e6)}`;
}
